import React from 'react';
import { AccommodationListingDTO } from '@apps/accommodations/AccommodationsConsole.types';
import { Box, Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';

interface CouplesPickProps {
  listing: AccommodationListingDTO;
}

export const CouplesPick = ({ listing }: CouplesPickProps) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');

  if (!listing.isPickedByCouple) {
    return null;
  }

  return (
    <Flex
      width="100%"
      justifyContent={{ _: 'flex-start', md: 'flex-end' }}
    >
      <Box
        paddingX={3}
        paddingY={1}
        borderRadius={2}
        color={'white'}
        backgroundColor={'mono14'}
      >
        <TextV2 typographyVariant="label2">{listing.type === 'roomBlock' ? listingTrans.couplesPickRoomBlock() : listingTrans.couplesPick()}</TextV2>
      </Box>
    </Flex>
  );
};
